import { render } from "./international_additional_infromation.vue?vue&type=template&id=818565f6&scoped=true"
import script from "./international_additional_infromation.vue?vue&type=script&lang=js"
export * from "./international_additional_infromation.vue?vue&type=script&lang=js"

import "./international_additional_infromation.vue?vue&type=style&index=0&id=818565f6&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-818565f6"]])

export default __exports__